import { TextProps } from '@features/powerpoint';

export const sharedCaptionCoords: TextProps['options'] = {
  h: 0.91,
  w: 2.48,
  y: 4.59,
};
